var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.447972 0.675781L9.79988 13.1802L0.388916 23.3467H2.50695L10.7462 14.4458L17.4033 23.3467H24.6111L14.733 10.139L23.4926 0.675781H21.3745L13.7866 8.87343L7.6557 0.675781H0.447972ZM3.56268 2.23593H6.87393L21.4959 21.7863H18.1846L3.56268 2.23593Z",
    fill: "#C7C7C7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterTwitter);
export default __webpack_public_path__ + "static/media/footerTwitter.2835b06668cbbfdf46601819be16efa1.svg";
export { ForwardRef as ReactComponent };